module.exports = __webpack_public_path__ + "fonts/3768D4_0_0.3bc49fd.woff2";